import { forwardRef, type ReactNode } from 'react';
import Input from '@mui/material/Input';
import InputAdornment from '@mui/material/InputAdornment';
import type { Nullish } from '@witmetrics/utils';
import { useDateFormatPreference } from '@witmetrics/data-store';
import { renderTimeframe } from '@/utils/time';
import { ArrowDownIcon, CalendarIcon } from '@/icons';
import { classes, styles } from './utils';

export type DateRangeTextInputProps = {
  open?: boolean;
  name: string;
  icon?: ReactNode;
  placeholder?: string;
  start: string | Nullish;
  end: string | Nullish;
  onClick: () => void;
};

const DateRangeTextInput = forwardRef<any, DateRangeTextInputProps>(
  (
    { open, name, icon, placeholder = 'Timeframe', start, end, onClick },
    ref
  ) => {
    const dateFormat = useDateFormatPreference();

    const value =
      start && end ? renderTimeframe(start, end, dateFormat) : placeholder;
    const inputProps = { id: name, value, onClick };
    return (
      <Input
        ref={ref}
        disableUnderline
        sx={styles.textInput(open)}
        {...inputProps}
        // An input has no content width, so size it to the rendered range
        inputProps={{ size: value.length + 2 }}
        startAdornment={
          <InputAdornment position="start">
            {icon ?? (
              <CalendarIcon
                className={classes.icon}
                size={16}
                strokeWidth={1.9}
              />
            )}
          </InputAdornment>
        }
        endAdornment={
          <InputAdornment position="end">
            <ArrowDownIcon className={classes.icon} size={14} />
          </InputAdornment>
        }
      />
    );
  }
);

export default DateRangeTextInput;
